export default __webpack_public_path__ + "static/media/scan.1af40a7f.svg";